/* IW PDP (iwp-*) — behaviour for sections/iwp-main-product.liquid.
   Gallery: one swipeable track; thumbnails (desktop) and dots (mobile) follow the scroll.
   Price: offer price + MRP come from the selected variant; discount %, savings and the
   EMI instalment are derived so they can never disagree. Add to cart is handled by the
   theme's <form is="product-form"> (cart drawer), so nothing here touches the cart. */
(function () {
  'use strict';

  function formatMoney(cents) {
    var format = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '₹{{amount_no_decimals}}';
    function delimit(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/), value;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', '.'); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    // Drop ".00" so ₹3,499.00 reads as ₹3,499, matching money_without_trailing_zeros.
    return format.replace(/\{\{\s*\w+\s*\}\}/, value.replace(/[.,]00$/, ''));
  }

  function init(root) {
    if (root.dataset.iwpReady) return;
    root.dataset.iwpReady = '1';
    var formId = root.dataset.formId;
    var form = document.getElementById(formId);
    var emiParts = parseInt(root.dataset.emiParts, 10) || 4;

    /* ---------- Gallery ---------- */
    var track = root.querySelector('[data-iwp-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-iwp-thumb]'));
    var dotsEl = root.querySelector('[data-iwp-dots]');
    var capL = root.querySelector('[data-iwp-cap-left]');
    var capR = root.querySelector('[data-iwp-cap-right]');
    var cur = 0, dots = [];

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function mark(i) {
      cur = i;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });
      dots.forEach(function (d, n) { d.className = n === i ? 'on' : ''; });
      if (capL && slides[i]) capL.textContent = slides[i].dataset.cap || '';
      if (capR) capR.textContent = pad(i + 1) + ' / ' + pad(slides.length);
      slides.forEach(function (s, n) {
        if (n !== i) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
      });
    }
    function go(i) {
      if (!track || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth });
      mark(i);
    }

    if (track && slides.length) {
      if (dotsEl && slides.length > 1) {
        slides.forEach(function () { dotsEl.appendChild(document.createElement('i')); });
        dots = Array.prototype.slice.call(dotsEl.children);
      }
      thumbs.forEach(function (b, i) { b.addEventListener('click', function () { go(i); }); });
      var st;
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== cur) mark(i);
        }, 60);
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      });
      window.addEventListener('resize', function () { track.style.scrollBehavior = 'auto'; track.scrollLeft = cur * track.clientWidth; track.style.scrollBehavior = ''; });
      var start = slides.findIndex(function (s) { return s.hasAttribute('data-initial'); });
      if (start > 0) { track.style.scrollBehavior = 'auto'; track.scrollLeft = start * track.clientWidth; track.style.scrollBehavior = ''; }
      mark(Math.max(0, start));
    }

    /* ---------- Zoom ---------- */
    var dlg = root.querySelector('[data-iwp-zoom-dialog]');
    var zoomBtn = root.querySelector('[data-iwp-zoom]');
    if (dlg && zoomBtn && typeof dlg.showModal === 'function') {
      var zoomImg = dlg.querySelector('img');
      zoomBtn.addEventListener('click', function () {
        var slide = slides[cur];
        var src = slide && slide.dataset.zoom;
        if (!src) return;
        zoomImg.src = src;
        zoomImg.alt = slide.querySelector('img') ? slide.querySelector('img').alt : '';
        dlg.showModal();
      });
      dlg.querySelector('button').addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    } else if (zoomBtn) {
      zoomBtn.hidden = true;
    }

    /* ---------- Price ---------- */
    function renderPrice(variant) {
      if (!variant) return;
      var p = variant.price, m = variant.compare_at_price || 0, has = m > p;
      var out = {
        price: formatMoney(p),
        mrp: formatMoney(m),
        off: has ? Math.round((m - p) / m * 100) + '% OFF' : '',
        save: has ? 'You save ' + formatMoney(m - p) : '',
        emi: formatMoney(Math.ceil(p / emiParts / 100) * 100)
      };
      root.querySelectorAll('[data-out]').forEach(function (el) {
        var k = el.dataset.out;
        if (k === 'mrp' || k === 'off' || k === 'save') {
          (el.closest('[data-iwp-sale]') || el).hidden = !has;
        }
        if (out[k] !== undefined) el.textContent = out[k];
      });
    }

    /* ---------- Buttons follow availability ---------- */
    var strings = (window.themeVariables && window.themeVariables.strings) || {};
    function renderButtons(variant) {
      root.querySelectorAll('[data-iwp-atc]').forEach(function (btn) {
        var label = btn.querySelector('[data-iwp-atc-label]');
        btn.disabled = !variant || !variant.available;
        if (label) {
          label.textContent = !variant ? (strings.unavailableButton || 'Unavailable')
            : variant.available ? (btn.dataset.label || strings.addToCartButton || 'Add to bag')
            : (strings.soldOutButton || 'Sold out');
        }
      });
      var pay = root.querySelector('.iwp-atc .shopify-payment-button');
      if (pay) pay.style.display = variant && variant.available ? '' : 'none';
    }

    if (form) {
      form.addEventListener('variant:change', function (e) {
        var v = e.detail && e.detail.variant;
        renderPrice(v);
        renderButtons(v);
        if (v && v.featured_media && track) {
          var idx = slides.findIndex(function (s) { return s.dataset.mediaId === String(v.featured_media.id); });
          if (idx > -1) go(idx);
        }
      });
    }

    /* ---------- Sticky bar: shown whenever the main button is off screen, hidden at the footer ---------- */
    var bar = root.querySelector('[data-iwp-sticky]');
    var cta = root.querySelector('[data-iwp-main-cta]');
    if (bar && cta) {
      var ctaVisible = true, footerVisible = false;
      var apply = function () { bar.classList.toggle('on', !ctaVisible && !footerVisible); };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { ctaVisible = en[en.length - 1].isIntersecting; apply(); }).observe(cta);
        var footer = document.querySelector('.shopify-section--footer, footer');
        if (footer) {
          new IntersectionObserver(function (en) { footerVisible = en[en.length - 1].isIntersecting; apply(); }).observe(footer);
        }
      }
    }

    /* ---------- Sticky Buy it now: presses the buy box's own Buy it now button so checkout is identical ---------- */
    var buyNow = root.querySelector('[data-iwp-buy-now]');
    if (buyNow && form) {
      // Shiprocket's button first: when it takes over, Shopify's hidden button is still in the DOM.
      var buyNowPicks = ['.sr-headless-checkout', '.shiprocket-headless button', '.shopify-payment-button__button', '.shopify-payment-button button'];
      var findBuyNow = function () {
        var box = root.querySelector('.iwp-atc');
        if (!box) return null;
        for (var i = 0; i < buyNowPicks.length; i++) {
          var hits = box.querySelectorAll(buyNowPicks[i]);
          for (var j = 0; j < hits.length; j++) if (hits[j].getClientRects().length) return hits[j];
        }
        return null;
      };
      buyNow.addEventListener('click', function () {
        var real = findBuyNow();
        if (real) { real.click(); return; }
        // No Buy it now button rendered: add the selected variant and go straight to checkout.
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        buyNow.setAttribute('aria-busy', 'true');
        fetch(base + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw r; window.location.href = base + 'checkout'; })
          .catch(function () { buyNow.removeAttribute('aria-busy'); form.requestSubmit ? form.requestSubmit() : form.submit(); });
      });
    }

    /* ---------- EMI: open Snapmint's plans popup ---------- */
    root.querySelectorAll('[data-iwp-emi]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (typeof window.startPop === 'function') { window.startPop(); return; }
        var sm = document.getElementById('sm-widget-btn');
        if (sm) sm.click();
      });
      // Sheen plays once the card is actually on screen (often below the gallery on mobile).
      if ('IntersectionObserver' in window) {
        var seen = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { btn.classList.add('is-seen'); seen.disconnect(); }
        }, { threshold: 0.6 });
        seen.observe(btn);
      }
    });

    /* ---------- Pincode: validates and shows an estimated delivery window ---------- */
    var pin = root.querySelector('[data-iwp-pin]');
    if (pin) {
      pin.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = pin.querySelector('input').value.trim();
        var status = pin.querySelector('[role=status]');
        if (!/^[1-9][0-9]{5}$/.test(v)) { status.textContent = pin.dataset.invalid; return; }
        var min = parseInt(pin.dataset.min, 10) || 5, max = parseInt(pin.dataset.max, 10) || 7;
        var fmt = function (d) { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); };
        var a = new Date(), b = new Date();
        a.setDate(a.getDate() + min); b.setDate(b.getDate() + max);
        status.innerHTML = '';
        var strong = document.createElement('strong');
        strong.textContent = (pin.dataset.prefix || 'Estimated delivery to') + ' ' + v + ': ' + fmt(a) + ' – ' + fmt(b) + '.';
        status.appendChild(strong);
        if (pin.dataset.note) status.appendChild(document.createTextNode(' ' + pin.dataset.note));
      });
    }
  }

  function boot() { document.querySelectorAll('[data-iwp-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
